module.exports = __webpack_public_path__ + "static/zoe-web-samsung-8dbab3540249270ac77ae6c4bb5d8080.jpg";